import { motion } from 'framer-motion';
import { Flame, Briefcase, Bookmark, LayoutDashboard } from 'lucide-react';

const TABS = [
  { key: 'home', label: 'HOME', Icon: Flame },
  { key: 'pulse', label: 'DASHBOARD', Icon: LayoutDashboard },
  { key: 'portfolio', label: 'MY PORTFOLIO', Icon: Briefcase },
  { key: 'saved', label: 'SAVED', Icon: Bookmark },
];

export default function BottomNav({ activeTab, onTabChange }) {
  return (
    <div className="bottom-nav" data-testid="bottom-nav">
      <div className="bg-black/85 backdrop-blur-xl rounded-2xl border border-white/10
        flex items-center justify-around py-2 px-2"
        style={{ boxShadow: '0 8px 24px rgba(0,0,0,0.5)' }}>
        {TABS.map(tab => {
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              data-testid={`nav-${tab.key}`}
              onClick={() => onTabChange(tab.key)}
              className="relative flex flex-col items-center gap-1 px-5 py-2 rounded-xl transition-all"
            >
              {isActive && (
                <motion.div
                  layoutId="nav-indicator-bg"
                  className="absolute inset-0 bg-gradient-to-r from-violet-500/25 to-fuchsia-500/25 rounded-xl"
                  style={{ border: '1px solid rgba(168,85,247,0.4)' }}
                />
              )}
              <tab.Icon
                size={22}
                strokeWidth={2.5}
                className={`relative z-10 transition-colors duration-200
                  ${isActive ? 'text-white' : 'text-white/85'}`}
                fill={isActive ? 'currentColor' : 'none'}
              />
              <span
                className={`text-[11px] font-black tracking-wider relative z-10
                transition-colors duration-200
                ${isActive ? 'text-white' : 'text-white/85'}`}
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
